import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, w100} from "@pg-design/helpers-css";
import {borderRadius, mr} from "@pg-design/helpers-css-strings";
import {InfoIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {Heading} from "../../../atoms/Heading";
import {MULTI_REGION_HEADER_LIMIT} from "../../constants/multi_region_header_limit";
import {ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";
import {OfferListPromotionLink} from "../../list/components/OfferListPromotionLink";
import {useOfferListingMapHeaderData} from "../hooks/use_offer_listing_map_header";

interface IProps {
    pageTitle: string;
    propertiesCount: number | null;
    offerCount: number;
    selectedRegion: ISelectedRegion[];
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
    onHeaderClick?: () => void;
}

export const MapHeader = React.memo((props: IProps) => {
    const {propertiesCount, offerCount, generatedDescriptionAllowed, onShowGeneratedDescription} = props;

    const theme = useTheme();
    const {isMobile} = useUserDevice();

    const {searchPhrase, regionName, regionsOverLimitCount} = useOfferListingMapHeaderData({multiRegionLimit: MULTI_REGION_HEADER_LIMIT});

    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    // Minimum promotions number needed to display link - business requirement
    const showPromotionsLink = !!promotionsCount && promotionsCount > 5;

    const multiRegionInfo = (
        <>{regionsOverLimitCount > 0 && <Text as="span" variant="body_copy_2" css={regionOverLimitTextWrapper}>{`+${regionsOverLimitCount}`}</Text>}</>
    );

    return (
        <div css={headingWrapper}>
            {generatedDescriptionAllowed && <InfoIcon css={info} onClick={onShowGeneratedDescription} size="2.4" />}

            <Heading type="div" padding="0">
                <Text as="h1" mb={1} variant="headline_6" onClick={props.onHeaderClick}>
                    {!isMobile ? (
                        <>
                            Mapa inwestycji <Highlight>{regionName}</Highlight> {multiRegionInfo} - {searchPhrase}
                        </>
                    ) : (
                        <>
                            Szukasz {searchPhrase}
                            <br />
                            <Highlight>{regionName}</Highlight> {multiRegionInfo}
                        </>
                    )}
                </Text>
                {propertiesCount != null && (
                    <Text as="div" color={theme.colors.gray[700]} variant="info_txt_1">
                        {numberFormat(propertiesCount)} {pluralize(["oferta", "oferty", "ofert"])(propertiesCount)} w {numberFormat(offerCount)}{" "}
                        {pluralize(["inwestycji", "inwestycjach", "inwestycjach"])(offerCount)}
                        {showPromotionsLink && <OfferListPromotionLink selectedRegion={props.selectedRegion} css={linkStyle} />}
                    </Text>
                )}
            </Heading>
        </div>
    );
});

export const headingWrapper = (theme: Theme) => css`
    gap: ${calculateRemSize(1)};
    ${flex("flex-start")};
    ${flexDirection("column")};
    ${w100};

    @media (min-width: ${theme.breakpoints.md}) {
        min-width: 57.3rem;
        width: 42%;
        min-height: 10.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        position: absolute;
        top: 0;
        right: 0;
        background-color: ${theme.colors.gray[100]};
        padding: 2rem;
    }
`;

const info = css`
    position: absolute;
    right: ${calculateRemSize(2)};
    cursor: pointer;
    top: ${calculateRemSize(8)};
`;

const linkStyle = (theme: Theme) => css`
    text-decoration: underline;
    color: ${theme.colors.gray[700]};

    @media (min-width: ${theme.breakpoints.md}) {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;

const regionOverLimitTextWrapper = css`
    ${mr(0.5)};
    ${borderRadius(3)};
    display: inline-flex;
    justify-content: center;
    vertical-align: middle;
    align-items: center;
    min-width: ${calculateRemSize(3.5)};
    height: ${calculateRemSize(3.5)};
    background: ${getThemeVariable("colors.primary")};
    cursor: pointer;
`;
import React from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {calculateRemSize, flex, flexDirection, w100} from "@pg-design/helpers-css";
import {borderRadius, mr} from "@pg-design/helpers-css-strings";
import {InfoIcon} from "@pg-design/icons-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat, pluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {Heading} from "../../../atoms/Heading";
import {MULTI_REGION_HEADER_LIMIT} from "../../constants/multi_region_header_limit";
import {ISelectedRegion} from "../../list/actions/offer_list_selected_data_actions";
import {OfferListPromotionLink} from "../../list/components/OfferListPromotionLink";
import {useOfferListingMapHeaderData} from "../hooks/use_offer_listing_map_header";

interface IProps {
    pageTitle: string;
    propertiesCount: number | null;
    offerCount: number;
    selectedRegion: ISelectedRegion[];
    generatedDescriptionAllowed: boolean;
    onShowGeneratedDescription: () => void;
    onHeaderClick?: () => void;
}

export const MapHeader = React.memo((props: IProps) => {
    const {propertiesCount, offerCount, generatedDescriptionAllowed, onShowGeneratedDescription} = props;

    const theme = useTheme();
    const {isMobile} = useUserDevice();

    const {searchPhrase, regionName, regionsOverLimitCount} = useOfferListingMapHeaderData({multiRegionLimit: MULTI_REGION_HEADER_LIMIT});

    const promotionsCount = props.selectedRegion.length === 1 && props.selectedRegion[0].stats ? props.selectedRegion[0].stats.promotions_count_total : 0;
    // Minimum promotions number needed to display link - business requirement
    const showPromotionsLink = !!promotionsCount && promotionsCount > 5;

    const multiRegionInfo = (
        <>{regionsOverLimitCount > 0 && <Text as="span" variant="body_copy_2" css={regionOverLimitTextWrapper}>{`+${regionsOverLimitCount}`}</Text>}</>
    );

    return (
        <div css={headingWrapper}>
            {generatedDescriptionAllowed && <InfoIcon css={info} onClick={onShowGeneratedDescription} size="2.4" />}

            <Heading type="div" padding="0">
                <Text as="h1" mb={1} variant="headline_6" onClick={props.onHeaderClick}>
                    {!isMobile ? (
                        <>
                            Mapa inwestycji <Highlight>{regionName}</Highlight> {multiRegionInfo} - {searchPhrase}
                        </>
                    ) : (
                        <>
                            Szukasz {searchPhrase}
                            <br />
                            <Highlight>{regionName}</Highlight> {multiRegionInfo}
                        </>
                    )}
                </Text>
                {propertiesCount != null && (
                    <Text as="div" color={theme.colors.gray[700]} variant="info_txt_1">
                        {numberFormat(propertiesCount)} {pluralize(["oferta", "oferty", "ofert"])(propertiesCount)} w {numberFormat(offerCount)}{" "}
                        {pluralize(["inwestycji", "inwestycjach", "inwestycjach"])(offerCount)}
                        {showPromotionsLink && <OfferListPromotionLink selectedRegion={props.selectedRegion} css={linkStyle} />}
                    </Text>
                )}
            </Heading>
        </div>
    );
});

export const headingWrapper = (theme: Theme) => css`
    gap: ${calculateRemSize(1)};
    ${flex("flex-start")};
    ${flexDirection("column")};
    ${w100};

    @media (min-width: ${theme.breakpoints.md}) {
        min-width: 57.3rem;
        width: 42%;
        min-height: 10.2rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        position: absolute;
        top: 0;
        right: 0;
        background-color: ${theme.colors.gray[100]};
        padding: 2rem;
    }
`;

const info = css`
    position: absolute;
    right: ${calculateRemSize(2)};
    cursor: pointer;
    top: ${calculateRemSize(8)};
`;

const linkStyle = (theme: Theme) => css`
    text-decoration: underline;
    color: ${theme.colors.gray[700]};

    @media (min-width: ${theme.breakpoints.md}) {
        text-decoration: none;
        color: ${theme.colors.secondary};
    }
`;

const regionOverLimitTextWrapper = css`
    ${mr(0.5)};
    ${borderRadius(3)};
    display: inline-flex;
    justify-content: center;
    vertical-align: middle;
    align-items: center;
    min-width: ${calculateRemSize(3.5)};
    height: ${calculateRemSize(3.5)};
    background: ${getThemeVariable("colors.primary")};
    cursor: pointer;
`;
